import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const orgBase = (organizationId) =>
  `${API_BASE_URL}/organizations/${organizationId}/payment-rails`;

export class PaymentRailsApi {
  static getCatalog = (organizationId) =>
    axios.get(`${orgBase(organizationId)}/catalog`);

  static list = (organizationId, paymentRailSettingId) =>
    axios.get(orgBase(organizationId), {
      params: { payment_rail_setting_id: paymentRailSettingId },
    });

  static get = (organizationId, id) =>
    axios.get(`${orgBase(organizationId)}/${id}`);

  static create = (organizationId, data) =>
    axios.post(orgBase(organizationId), data);

  static update = (organizationId, id, data) =>
    axios.put(`${orgBase(organizationId)}/${id}`, data);

  static delete = (organizationId, id) =>
    axios.delete(`${orgBase(organizationId)}/${id}`);
}
